
import { Box, Card, CardContent, Container, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { toast } from 'react-toastify';
import axios from "axios";
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { GET_STOCK_TRANSFER_LIST } from '../../../common/URLs';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { ViewIcon } from '../../../common/icons';
import { useNavigate } from 'react-router-dom';

export default function StockTransferList() {
    const navigate = useNavigate();
    const [stockListData, setStockListData] = useState();

    useEffect(() => {
        getStockTransferRequestList();
    }, []);

    const getStockTransferRequestList = (e) => {
        loaderService.showLoader();
        axios
            .post(GET_STOCK_TRANSFER_LIST,
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStockListData(response.data.stockTransferDetailsList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const columns = [
        { field: "stockTransferNumber", headerName: 'Stock Transfer Number', width: 180 },
        { field: 'financialYear', headerName: 'Financial Year', width: 120 },
        { field: 'month', headerName: 'Month', width: 100 },
        {
            field: 'materialType', headerName: 'Material Type', width: 150,
            valueGetter: (params) => {
                if (params.row.materialType === "rawbamboo") {
                    return "Raw Bamboo"
                } else if (params.row.materialType === "chipbamboo") {
                    return "Chip Bamboo"
                }
                else return ""

            }
        },
        { field: 'stockTransferQuantity', headerName: 'Quantity(MT)', width: 100 },
        { field: 'sourceStakeholderType', headerName: "Source Type", width: 150 },
        { field: 'sourceStakeholderUrn', headerName: "Source URN", width: 150 },
        { field: 'sourceStakeholderName', headerName: "Source Name", width: 200 },
        { field: 'sourceStakeholderAddress', headerName: 'Source Address', width: 250 },
        { field: 'destinationStakeholderType', headerName: "Destination Type", width: 150 },
        { field: 'destinationStakeholderUrn', headerName: "Destination URN", width: 150 },
        { field: 'destinationStakeholderName', headerName: "Destination Name", width: 200 },
        { field: 'destinationStakeholderAddress', headerName: 'Destination Address', width: 250 },
        // {
        //     field: 'action', headerName: 'Select Bundle', width: 250,
        //     renderCell: (params) => {
        //         return (
        //             <Tooltip title="View">
        //                 <IconButton variant="contained"
        //                     color="primary"
        //                     onClick={(e) => navigate("/nonTransporterStockTransfer/nstrDetails", {
        //                         state: { selectedNSTR: params.row }
        //                     })}
        //                 >
        //                     <ViewIcon />
        //                 </IconButton>
        //             </Tooltip>
        //         );
        //     }
        // },
    ];

    return (
        <Container maxWidth="xxl">
            <Typography variant="h4" gutterBottom>
                Stock Transfer Request List
            </Typography>
            <Card>
                <CardContent>
                    <Grid container spacing={1} direction="row">
                        <Box style={{ height: 400, width: '100%' }}>
                            {
                                stockListData &&
                                <DataGrid sx={{
                                    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                                    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                                    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' },
                                }}
                                    getRowHeight={() => 'auto'}
                                    rows={stockListData}
                                    columns={columns}
                                    pageSize={10}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                />
                            }
                        </Box>
                    </Grid>
                </CardContent>
            </Card>
        </Container>
    );
}